<script lang="ts">
import { defineComponent } from 'vue'

import Button from '@mobile/components/Button/Button.vue'

export default defineComponent({
  components: { Button },
  props: {
    disableButtons: {
      type: Boolean,
      default: false,
    },
    confirmButtonText: {
      type: String,
      default: 'Save & continue',
    },
    cancelButtonText: {
      type: String,
      default: 'Cancel',
    },
  },
  emits: ['confirm', 'cancel'],
})
</script>

<template>
  <div ref="rootElement">
    <template v-if="!disableButtons">
      <div class="pointer-events-none absolute bottom-0 w-full p-4">
        <slot name="buttons">
          <div class="flex justify-between">
            <Button
              :color="'red'"
              :size="'lg'"
              @click="$emit('cancel')"
            >
              {{ cancelButtonText }}
            </Button>
            <div class="flex items-center gap-4">
              <slot name="additionalButton" />
              <Button
                :color="'green'"
                :size="'lg'"
                @click="$emit('confirm')"
              >
                {{ confirmButtonText }}
              </Button>
            </div>
          </div>
        </slot>
      </div>

      <teleport to="#popup-controls-padding">
        <div class="h-20 w-full"></div>
      </teleport>
    </template>
  </div>
</template>

<style scoped lang="scss">
@use '@mobile/styles/variables.scss' as vars;

.swipe-indicator {
  display: flex;
  width: 2px;
  position: fixed;
  top: 0;
  bottom: 0;
  border-radius: 100%;
  justify-content: center;
  align-items: center;

  &-left {
    left: -10px;
    box-shadow: 0 0px 32px 1px vars.$red;
  }

  &-right {
    right: -10px;
    box-shadow: 0 0px 32px 1px vars.$green;
  }
}

.swipe-incicator-button {
  position: fixed;
  width: 12px;
  height: 70px;
  border-radius: 100%;

  &-left {
    background: rgba(vars.$red, 0.7);
    left: -8px;
  }

  &-right {
    background: rgba(vars.$green, 0.7);
    right: -8px;
  }

  &-higher {
    margin-top: -50px;
  }
}
</style>
